import { CSSProperties, useContext, useEffect, useState } from "react";
import { UserGroup } from "../../../models/UserGroup";
import { UserGroupContract } from "../../../models/UserGroupContract";
import UserGroupContractService from "../../../services/crud/UserGroupContractService";
import { Alert, Button, Card, Col, Empty, List, Row, Spin } from "antd";
import { ToastContext } from "../../../context/ToastContext";
import { AccountsUserGroupContractView } from "./AccountsUserGroupContractView";
import { formatDate } from "../../../utils/dates";

export type AccountsUserGroupsTabProps = {
  accountId: number;
  userGroupId: number;
};

enum _LoadingState {
  loading,
  error
}

/**
 * This page lists all company accounts.
 * @param param0
 * @returns
 */
export function ContractsView({accountId, userGroupId}: AccountsUserGroupsTabProps) {
  const [userGroupContracts, setUserGroupContracts] = useState<UserGroupContract[]|_LoadingState|null>(null);
  const [selectedContractId, setSelectedContractId] = useState<number|null>(null);
  const [selectedContract, setSelectedContract] = useState<UserGroupContract|_LoadingState|null>(null);
  const [lastContractId, setLastContractId] = useState<number|null>(null);
  const { loading, loadMessage, showMessage } = useContext(ToastContext);

  useEffect(() => {
    setUserGroupContracts(null);
    setSelectedContractId(null);
    setSelectedContract(null);
    setLastContractId(null);
    reloadContracts();
  }, [accountId, userGroupId]);

  const reloadContracts = async () => {
    setUserGroupContracts(_LoadingState.loading);
    let value: UserGroupContract[]|null = null;
    try {
      value = await UserGroupContractService.listUserGroupContractsOnUserGroup(userGroupId);
    } catch {
      setUserGroupContracts(_LoadingState.error);
      return;
    }
    UserGroupContract.sortUserGroupContractsByDate(value);
    setUserGroupContracts(value);
    const _lastContractId = value.length > 0 ? value[value.length - 1].id : null;
    setLastContractId(value.length > 0 ? value[value.length - 1].id : null);
    // auto select last contract
    setSelectedContractId(_lastContractId);
  }

  // loads selected contract
  useEffect(() => {
    if (selectedContractId != null) {
      setSelectedContract(_LoadingState.loading);
      UserGroupContractService.getUserGroupContract(selectedContractId).then((value) => {
        setSelectedContract(value);
      }).catch((_) => {
        setSelectedContract(_LoadingState.error);
      });
    } else {
      setSelectedContract(null);
    }
  }, [selectedContractId]);

  const nContracts = userGroupContracts !== null && typeof userGroupContracts === 'object' ? userGroupContracts.length : null;
  const selectedButton: CSSProperties = {
    fontWeight: 700,
    borderColor: '#1819ff',
  };
  const leftBorderStyle: CSSProperties = {
    //borderLeft: '1px solid #eeeeee',
    paddingLeft: 12,
  };

  const addUserGroupBtn = <Button
      style={{flex: 1}}
      type="primary"
      //onClick={() => openCreateUserGroup(accountId)}
    >{ 'Lägg till lägenhet' }</Button>;

  const addContractBtn = (style: CSSProperties) => <Button
      style={style}
      type="primary"
      //onClick={openAddContractModal}
    >{ (nContracts ?? 0) > 0 ? 'Omflytt' : 'Första inflytt' }</Button>;

  const contractColError = userGroupContracts === _LoadingState.error
            || (selectedContractId !== null && selectedContract === _LoadingState.error)
  const contractColLoading = !contractColError && (userGroupContracts === _LoadingState.loading
            || (selectedContractId !== null && selectedContract === _LoadingState.loading))

  return <>
    <Row gutter={[16, 16]}>
      <Col xs={6} md={6} lg={6} style={leftBorderStyle}>
        {
          userGroupContracts === null || userGroupContracts === _LoadingState.loading
            ? <Spin tip="Hämtar kontrakt.." />
            : (
              userGroupContracts === _LoadingState.error
                ? <Alert message="Misslyckades ladda, byt lägenhet och tillbaka igen för att försöka igen" />
                : <div>
                    <h3>Kontrakt</h3>
                    <div style={{overflowX: 'scroll', maxHeight: '50vh', paddingRight: 14}}>
                      <List dataSource={userGroupContracts} split={false}
                        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Inga kontrakt" /> }}
                        renderItem={(item, index) => (
                          <List.Item key={item.id} style={{ padding: "4px 0" }}>
                            <Button style={{...(item.id === selectedContractId ? selectedButton : {}), flex: 1, height: "auto", whiteSpace: "normal"}}
                              aria-selected={item.id === selectedContractId}
                              onClick={(): void => setSelectedContractId(item.id)}
                            >
                              {item.label}<br/>
                              {/*item.members !== null && item.members.length > 0 && (
                                <>{item.members?.map((m) => m.username)?.join(' ')}<br/></>
                              )*/}
                              {item.startDate !== null && (
                                <>in: {formatDate(item.startDate)}<br/></>
                              )}
                              {item.endDate !== null && (
                                <>ut: {formatDate(item.endDate)}<br/></>
                              )}
                            </Button>
                          </List.Item>
                        )} />
                    </div>
                    { /*
                    <List.Item key={-1} style={{ padding: "8px 14px 0 0" }}>
                      { addContractBtn({flex: 1}) }
                    </List.Item>
                    */}
                  </div>
            )
        }
      </Col>
      <Col xs={24-6} md={24-6} lg={24-6}
        style={leftBorderStyle}
      >
        <div>
          <h3>Hyresperiod</h3>

          <Card>
            <div>
              <b>Inflytt: </b>
              <span>{ selectedContract !== null && typeof selectedContract === 'object' ? selectedContract?.startDate?.toLocaleString() ?? '-' : '-'}</span>
            </div>
            <div>
              <b>Utflytt: </b>
              <span>{ selectedContract !== null && typeof selectedContract === 'object' ? selectedContract?.endDate?.toLocaleString() ?? '-' : '-'}</span>
            </div>
            { /*selectedContractId === lastContractId && addContractBtn({minWidth: 150, marginTop: 24}) */ }
          </Card>

          <h3 style={{marginTop: 24}}>
            Boende
            {
              //simpleView ? selectedUserGroupLabel :
              //`Kontrakt ${typeof selectedContract === 'object' ? selectedContract?.label ?? '1' : '1'}`
            }
          </h3>

          <Card>

          {
            contractColError && <Alert />
          }
          {
            contractColLoading && <Spin delay={200} tip="Läser in" />
          }
          {
            !contractColError && !contractColLoading &&
            nContracts === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Inga boende" />
            //addContractBtn({})
          }
          {
            !contractColError && !contractColLoading &&
            nContracts !== null && nContracts > 0 && (

              selectedContractId !== null && typeof selectedContract === 'object' && selectedContract !== null
                ? <>
                  <AccountsUserGroupContractView
                    userGroupContract={selectedContract}
                  />
                  { /*selectedContractId === lastContractId && (
                  <div style={{marginTop: 36, display: 'flex', gap: 8}}>
                    <Button
                      style={{minWidth: 150}}
                      //onClick={openEditContractModal}
                    >Redigera</Button>
                  </div>
                  ) */}
                  {/*
                  <section style={{marginTop: 36}}>
                    <h3>
                      Levererad Mobilitet
                    </h3>
                    <p>
                      Välkomstpaket<br/>
                      300 kr mobilitetspott<br/>
                      1st voucher bilpool<br/>
                      1st voucher cykelpool
                    </p>
                  </section>
                  */}
                </>
                : <Spin delay={200} tip="Läser in" />
            )
          }
          </Card>
        </div>

      </Col>

    </Row>
  </>
}
